import { useEffect, useRef } from "react";
import * as api from "../lib/api";

const POLL_MS = 30_000;

/**
 * Polls /sync/status every 30s. Calls onComplete when a new completed_at
 * timestamp is detected — i.e. a background auto-sync just finished.
 */
export function useAutoSyncRefresh(onComplete) {
  const lastCompletedAt = useRef(null);
  const callbackRef = useRef(onComplete);

  useEffect(() => { callbackRef.current = onComplete; }, [onComplete]);

  useEffect(() => {
    const check = async () => {
      try {
        const s = await api.getSyncStatus();
        const ts = s.completed_at || null;
        if (s.status === "completed" && ts && ts !== lastCompletedAt.current) {
          lastCompletedAt.current = ts;
          callbackRef.current?.();
        }
      } catch {
        // silent — background poll
      }
    };

    const id = setInterval(check, POLL_MS);
    return () => clearInterval(id);
  }, []);
}
